/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_itemSearch$ref = any;
export type SbSharedRefineMenuFilterStone_itemSearch$ref = any;
export type SbSharedRefineMenuFilterStone_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterStone_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterStone_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '81fc1403c4474ba95e83c72409ee2007';
export default node;
